<template>
  <!-- 入仓登记 라벨 한 장 — 箱子标签과 같은 80×60mm 라벨지. 인쇄 창(vue-html-to-paper)이 HTML 만 복사하므로 스타일은 전부 인라인 -->
  <div style="width:80mm;height:60mm;box-sizing:border-box;padding:2mm 3mm;display:flex;flex-direction:column;overflow:hidden;font-family:Arial,'Microsoft YaHei',sans-serif;color:#000;background:#fff">
    <div style="display:flex;justify-content:space-between;align-items:flex-start;line-height:1.1">
      <!-- 고객명 크게(2026-10-04 YZY) -->
      <div style="font-size:28px;font-weight:bold;max-width:50mm;overflow:hidden;white-space:nowrap">{{ d.companyid }}</div>
      <div style="font-size:22px;font-weight:bold;white-space:nowrap">{{ d.location }}</div>
    </div>
    <!-- 주문번호 바코드 — 入库处理 에서 그대로 스캔해 찾는 번호(기본 검색 = 1688订单号) -->
    <div style="flex:0 0 14mm;text-align:center;line-height:0;margin-top:1mm;overflow:hidden">
      <barcode v-if="d.orderNo" :value="d.orderNo" format="CODE128" :height="52" :width="1.7" :margin="0" :display-value="false"></barcode>
    </div>
    <div style="text-align:center;font-size:11px;line-height:1.2">{{ d.orderLabel }} {{ d.orderNo || '-' }}</div>
    <!-- 快递单号(2026-10-04 YZY) — 글자만 한 줄. 위 칸 크기는 그대로 -->
    <div v-if="d.waybill" style="text-align:center;font-size:12px;font-weight:bold;line-height:1.2;white-space:nowrap;overflow:hidden">快递单号 {{ d.waybill }}</div>
    <div style="font-size:17px;font-weight:bold;line-height:1.2;margin-top:1mm;text-align:center;white-space:nowrap;overflow:hidden">清关方式 {{ d.customs || '-' }}</div>
    <div :style="d.outboundStyle" style="margin-top:1mm;padding:1mm 2mm;font-size:15px;font-weight:bold;text-align:center;border:2px solid #000;-webkit-print-color-adjust:exact;print-color-adjust:exact;white-space:nowrap;overflow:hidden">
      <b>出库形式</b> {{ d.outbound || '-' }}
    </div>
    <!-- 맨 아래 한국어 품명은 뺐다(2026-10-04 YZY) — 중국어 옵션만 -->
    <div v-if="d.name" style="font-size:10px;line-height:1.2;margin-top:auto;text-align:center;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{{ d.name }}</div>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';
import { customsTypeText, outboundTypeOfReq, outboundTypeText, outboundTypeStyle } from '@/utils/coupassStatusText';

// 화면 표기의 「(한국어)」 괄호만 뗀다 — 한글이 든 괄호만(중국어 괄호는 둔다)
function stripKo(v) {
  return String(v || '').replace(/\([^)]*[가-힣][^)]*\)/g, '').trim();
}

// 快递单号 — 입창 때 찍은 번호가 있으면 그것, 없으면 그 건의 운송장(수동 → 1688). 여러 개면 첫 번째 + 等N个
function waybillText(r, waybill) {
  const fixed = waybill || (r.입창등록 && r.입창등록.운송장번호);
  if (fixed) return String(fixed);
  const 물류 = r.물류정보 || {};
  const 수동 = 물류.수동 && Array.isArray(물류.수동.운송장번호목록) ? 물류.수동.운송장번호목록 : [];
  const list = [...new Set(수동.concat(물류.운송장번호 || [], 물류.운송장번호목록 || []).filter(Boolean).map(String))];
  if (!list.length) return '';
  return list[0] + (list.length > 1 ? ' 等' + list.length + '个' : '');
}

// 라벨에 찍을 값 — 행(Reqpurchase) + 입창 위치번호 (+ 입창 때 찍은 운송장)
export function inboundLabelData(row, location, waybill) {
  const r = row || {};
  const no1688 = (r.주문정보 && r.주문정보['1688주문번호']) || '';
  const outbound = outboundTypeOfReq(r);
  return {
    companyid: r.companyid || '',
    location: location || (r.입창등록 && r.입창등록.위치번호) || '',
    // 입고처리 검색 기본값이 1688订单号 라서 그 번호를 찍는다. 1688 번호가 없는 건만 货主订单号
    orderNo: String(no1688 || r.화주주문번호 || ''),
    orderLabel: no1688 ? '1688订单号' : '货主订单号',
    // 라벨은 중국어만(2026-10-04 YZY) — 화면 표기의 (한국어) 괄호를 뗀다. 出库形式 도 같다
    customs: stripKo(customsTypeText(r.요청내역 && r.요청내역.customsType)),
    outbound: stripKo(outboundTypeText(outbound)),
    outboundStyle: outboundTypeStyle(outbound),
    name: [r.옵션1_중국어, r.옵션2_중국어].filter(Boolean).join(' '),
    waybill: waybillText(r, waybill)
  };
}

export default {
  name: 'InboundLabel',
  components: { barcode: VueBarcode },
  props: {
    row: { type: Object, required: true },
    location: { type: String, default: '' },
    waybill: { type: String, default: '' }
  },
  computed: {
    d() {
      return inboundLabelData(this.row, this.location, this.waybill);
    }
  }
};
</script>
